import { Component, Prop, Vue } from 'vue-property-decorator';

import { Meta } from '@/store/models';
import template from './Pagination.vue';

@Component({
	mixins: [template],
	filters: {
		actualPage(link: string): string {
			return link.split('page=')[1].split('&')[0];
		}
	}
})
export default class Pagination extends Vue {
	@Prop() meta!: Meta;

	@Prop() loading: boolean = false;

	get getPrev(): Object | boolean {
		if (this.meta && this.meta.firstId) {
			return Object.assign({}, { previousFirstId: this.meta.firstId });
		}
		return false;
	}

	get getNext(): Object | boolean {
		if (this.meta && this.meta.lastId) {
			return Object.assign({}, { previousLastId: this.meta.lastId });
		}
		return false;
	}
}
